"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyExpression = emptyExpression;
function emptyExpression() {
    return { extType: 'kibsi', plainText: '' };
}
//# sourceMappingURL=index.js.map